var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.61719 2.40039V20.5148",
    stroke: "#2E283C",
    strokeWidth: 1.80111,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8438 2.82422V20.9387",
    stroke: "#2E283C",
    strokeWidth: 1.80111,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0703 2.82422V20.9387",
    stroke: "#2E283C",
    strokeWidth: 1.80111,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19922 4.97982V8.58203H7.52187V4.97982H3.19922Z",
    fill: "#2E283C",
    stroke: "#2E283C",
    strokeWidth: 0.900553,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68359 15.0658V18.668H14.0062V15.0658H9.68359Z",
    fill: "#2E283C",
    stroke: "#2E283C",
    strokeWidth: 0.900553,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.168 7.13998V10.7422H20.4906V7.13998H16.168Z",
    fill: "#2E283C",
    stroke: "#2E283C",
    strokeWidth: 0.900553,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSetting);
export default __webpack_public_path__ + "static/media/ic_setting.7da1493be9b8e375c14c4fa08b3e812b.svg";
export { ForwardRef as ReactComponent };